import TierBadge from './TierBadge';

export default TierBadge;
